<mat-card-footer class="card-footer">
  <ng-content></ng-content>
</mat-card-footer>
